<template>
    <div>
        <div class="item-all-pro">
            <div class="item-all-pro-ba" style="position: relative; left: 0px; top: 0px; margin-left: 0px;">
                <div class="item-all-pro-ba-time">
                    <ul class="item-all-pro-ba-time-palam" style="left:0;width:1288px;">
                        <li class="item-all-pro-ba-time-palam-time" v-for="(item,index) in timeList" :key="index" >
                            <a href="javascript:;" @click="beforeClick(item.begin_time)" class="item-all-pro-ba-time-palam-time-a" v-if="item.types == '已结束'">
                                <p>
                                    <span>{{$fnc.getTimeHour(item.begin_time)}}</span>
                                    <span class="item-all-pro-ba-time-palam-time-a-span">已结束</span>
                                </p>
                            </a>
                            <a href="javascript:;" @click="nowClick(item.begin_time)" class="item-all-pro-ba-time-palam-time-current" v-else-if="item.types == '已开始'">
                                <p>
                                    <span>{{$fnc.getTimeHour(item.begin_time)}}</span>
                                    <span>正在疯抢</span>
                                </p>
                                <p>
                                    <span>距结束</span>
                                    <times v-if="ends_time" :endTime="ends_time" endText="已经结束了"></times>
                                </p>
                            </a>
                            <a href="javascript:;" @click="afterClick(item.begin_time)" class="item-all-pro-ba-time-palam-time-a" v-else>
                                <p>
                                    <span>{{$fnc.getTimeHour(item.begin_time)}}</span>
                                    <span class="item-all-pro-ba-time-palam-time-a-span">未开始</span>
                                </p>
                            </a>
                        </li>
                        <div class="clear"></div>
                    </ul>
                    <div class="prev btna"></div>
                    <div class="next btna"></div>
                </div>
            </div>
        </div>

        <div class="over mt35" style="width:1200px;">
            <div style="margin-top:28px;">
                <div class="tpbj" v-for="(item,index) in list" :key="index">
                    <router-link :to="{path:'/ms_detail', query:{id:item.id}}" target="_blank" style="padding:25px 10px;overflow: hidden;display: block;text-align:center;">
                        <img :src="item.piclink" width="350" height="350" alt="">
                        <div style="background:#ffffff;">
                            <p style="padding: 14px 18px;font-size: 18px;line-height: 30px;overflow: hidden;">{{item.title | ellipsis}}</p>
                            <p>
                                <span style="float:left;margin-right:10px;font-size:14px;">已售{{$fnc.toFixedZ(item.sold,2)}}%</span>
                                <span><limit-percent :num="Number(item.sold)"></limit-percent></span>
                            </p>
                            <p style="line-height:25px;margin-top:20px;">
                                <span style="font-size:26px;color:#f00180;font-weight:bold;float:left;">￥{{item.limited_price}}</span>
                                <span style="float:left;text-decoration:line-through">￥{{item.price}}</span>
                                <span style="background:#f00180;font-size:16px;color:#fff;padding:5px 10px;border-radius:10px;float:right;">立即抢购</span>
                            </p>
                            
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Times from '../common/time_detail.vue';
import Limit_percent from "./limit_percent"
export default {
    components:{
        'limit-percent' : Limit_percent,
        "times":Times,
    },
    filters: {//限制文本显示字数,超出部分用...代替
        ellipsis (value) {
        if (!value) return ''
        if (value.length > 10) {
            return value.slice(0,15) + '...'//0:下标,从第一个字开始显示,50:显示字数,多余用...代替
        }
        return value
        }
    },
    data() {
        return {
            percent: 50,
            calleft: 0,
            list:[],
            tableData: {
                data: [],
                total: 0,
            },
            listLoading: true,
            LogLoading: false,
            dialogVisible: false,

            tableFrom: {
                order_sn: this.$route.query.order_sn ? this.$route.query.order_sn : "",
                keywords: "",
                page: 1,
                limit: 20,
                type: "1",
                title: "",
                sid_cn: "",
                cate_id: this.$route.query.cate_id ? this.$route.query.cate_id : "",
            },
            isActive:false,
            timeList:[],
            types:"",
            begins_time:"",
            ends_time:"",
            onlyTimeList:[],
        };
    },
    mounted(){
        this.getXianshiqianggou();
        this.getTime();
    },
    methods:{
        getTime(){
            this.$api.getShop.getEveryday({}).then(ress => {
                if (ress.code == 200) {
                    let nowTime = new Date();
                    this.timeList = [];
                    var arr = ress.result;
                    arr.forEach((item,index)=>{
                        this.begins_time = item.begin_time;
                        if(this.begins_time*1000 < nowTime.getTime()){
                            this.ends_time = item.end_time;
                        }
                        this.timeList.push(item);
                    })
                }
            });
        },
        getXianshiqianggou() {
            this.$api.getShop.getXianshiqianggou({}).then(res => {
                if (res.code == 200) {
                    this.end_time = res.result[0].end_time;
                    var id = res.result[0].id;
                    var params = {};
                    params.id = id || "";
                    this.$api.getShop.getXsqgList(params).then(ress => {
                        if (ress.code == 200) {
                            this.list = ress.result;
                        }
                    });
                }
            });
        },
        beforeClick(begin_time){
            var params = {};
            params.begin_time = begin_time || "";
            this.$api.getShop.getOnlyTimeList(params).then(res=>{
                if(res.code == 200){
                    this.list = res.result;
                }
            })
            
        },
        nowClick(begin_time){
            var params = {};
            params.begin_time = begin_time || "";
            this.$api.getShop.getOnlyTimeList(params).then(res=>{
                if(res.code == 200){
                    this.list = res.result;
                }
            })
        },
        afterClick(begin_time){
            var params = {};
            params.begin_time = begin_time || "";
            this.$api.getShop.getOnlyTimeList(params).then(res=>{
                if(res.code == 200){
                    this.list = res.result;
                }
            })
        },
    }
}
</script>

<style scoped>
.btna {
    position: absolute;
    text-align: center;
    /* left: 0; */
    bottom: 10px;
    width: 100%;
}
.item-all-pro{
    width: 1200px;
    height: 60px;
}
.item-all-pro-ba{
    width: 1200px;
    height: 60px;
}
.item-all-pro-ba-time{
    position: relative;
    overflow: hidden;
    /* margin: 50px auto 0; */
    width: 1200px;
    height: 60px;
    border-bottom: 2px solid #F8264A;
    background: #fff;
}
.item-all-pro-ba-time-palam{
    margin-left: 40px;
    position: absolute;
    top: 0;
    left: 0;
    width: auto;
    height: 100%;
}
.item-all-pro-ba-time-palam-time{
    float: left;
    height: 60px;
    text-align: center;
    padding-right: 5px;
    background: #fff;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    font-family: PingFangSC-Medium;
}
.item-all-pro-ba-time-palam-time .item-all-pro-ba-time-palam-time-a {
    display: block;
    width: 156px;
    height: 60px;
    line-height: 60px;
    font-weight: bold;
}
/* .item-all-pro-ba-time-palam-time .item-all-pro-ba-time-palam-time-a p:hover{
    color: #f00180;
} */
.item-all-pro-ba-time-palam-time .item-all-pro-ba-time-palam-time-current {
    display: block;
    width: 156px;
    height: 60px;
    font-weight: bold;
}
.item-all-pro-ba-time-palam-time-current{
    background: url(../../assets/picture/miaosha/icon-current-time-bg.png) no-repeat;
    line-height: normal;
    padding-top: 10px;
    font-family: 微软雅黑;
    color: #fff;
}
.item-all-pro-ba-time-palam-time-a-span{
    border: 1px solid #666;
    padding: 0 14px;
    vertical-align: middle;
    height: 26px;
    line-height: 25px;
    color: #666;
    -moz-border-radius: 22px;
    border-radius: 22px;
    font-size: 12px;
    display: inline-block;
    margin-left: 10px;
}
.item-all-pro-ba-time .prev {
    left: -10px;
    background: url(../../assets/picture/miaosha/arrow-left.png) center no-repeat #fff;
}
.item-all-pro-ba-time .next {
    right: -10px;
    background: url(../../assets/picture/miaosha/arrow-right.png) center no-repeat #fff;
}

.item-all-pro-ba-time .btna {
    position: absolute;
    width: 50px;
    height: 65px;
    top: 0;
    cursor: pointer;
}
.clear {
    clear: both;
    display: block;
    height: 0;
    overflow: hidden;
    font-size: 0;
}
.item-all-pro-ba-time{
    width: 1200px;
    height: 60px;
    /* z-index: 888; */
}
.tpbj{
	background: url(../../assets/picture/index/tpbj.png) no-repeat;
	width: 385px;
	height: 534px;
	/* position: absolute; */
	float: left;
	margin-right: 15px;
	margin-bottom: 25px;
}
/* .tpbj a:hover{
	border:1px solid #dedede;
	color:#f00180;
	border-radius: 10px;
} */
.btn-buy{
	background: url(../../assets/picture/index/btn.png) no-repeat;
	width: 165px;
	height: 36px;
	line-height: 36px;
	color: #ffffff;
	text-align: center;
	margin-left: 22%;
	font-size: 18px;
}
a:hover{
	text-decoration:none;
	color: #f00180;
}
</style>


// WEBPACK FOOTER //
// src/components/pintuan/miaosha.vue